import React, {useEffect} from 'react'
import Post from './Post/Post'
import {useSelector, useDispatch} from 'react-redux'
import {fetchPosts} from '../../features/posts/postthunk'
import {CircularProgress, Grid,  } from '@mui/material'
const Posts = ({handleOpen}) => {
  const { prevPosts} = useSelector((state)=> state.posts)
  const dispatch = useDispatch()
  useEffect(() => {
dispatch(fetchPosts())
  },[dispatch])


  return (
      <>
        <Grid container sx={{marginTop:'2rem',columnGap:'0.5rem', rowGap:'0.5rem'}}>
 { prevPosts?.length < 1? <CircularProgress /> : 
   prevPosts?.map((post, index)=>(
   <Grid key={index} item>
     <Post  post={post} handleOpenFormModal={handleOpen} />
   </Grid>
   ))
 }
        </Grid>
      
      </>
  
  )
}

export default Posts